(function () {
  "use strict";
  /* Wade Greens - mobile menu tabs.
     Below 1025px each tab panel receives the matching header modal's content,
     and each tab's icon is masked from the same image the desktop modal button
     uses, so the header stays the single source of truth.

     WHY MASKS AND NOT <img>
     The four modal icons are white-on-transparent PNGs. Dropped onto the white
     tab strip as plain images they are invisible, so they are applied as a CSS
     mask and `background-color` supplies the colour. That also removes every
     hook iOS uses to tint an icon: no SVG fill, no currentColor, no inherited
     link colour. The theme's own <svg> is hidden, not deleted, and restored
     above the breakpoint.

     SHOP is the one tab with no modal behind it, so it carries a built-in
     storefront glyph drawn to the same stroke weight as the other four. It is
     inlined as a data URI - no extra request, nothing to upload, and it is
     masked like the rest so iOS cannot recolour it either. */

  var BREAKPOINT = 1025;

  var MAP = [
    ["share", "modalOne"], ["subscribe", "modalOne"],
    ["faq", "modalTwo"], ["help", "modalTwo"],
    ["deal", "modalThree"], ["promo", "modalThree"], ["discount", "modalThree"],
    ["feedback", "modalFour"], ["contact", "modalFour"]
  ];

  var SHOP_KEY = "wgShop";
  var SHOP_ICON = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik00LjMgMTAuMlYyMGEuOC44IDAgMCAwIC44LjhoMTMuOGEuOC44IDAgMCAwIC44LS44di05LjgiLz48cGF0aCBkPSJNMi42IDYuNiA0LjIgMy41YS45LjkgMCAwIDEgLjgtLjVoMTRhLjkuOSAwIDAgMSAuOC41bDEuNiAzLjEiLz48cGF0aCBkPSJNMi42IDYuNmEyLjQgMi40IDAgMCAwIDQuODUgMCAyLjQgMi40IDAgMCAwIDQuODUgMCAyLjQgMi40IDAgMCAwIDQuODUgMCAyLjQgMi40IDAgMCAwIDQuMjUgMCIvPjxwYXRoIGQ9Ik05LjYgMjAuOHYtNS4yaDQuOHY1LjIiLz48L3N2Zz4=";

  function labelOf(tab) {
    var el = tab.querySelector(".nm-tab-label");
    return ((el ? el.textContent : tab.textContent) || "")
      .replace(/\s+/g, " ").trim().toLowerCase();
  }

  function modalIdFor(tab) {
    var text = labelOf(tab);
    if (!text) return null;
    for (var i = 0; i < MAP.length; i++) {
      if (text.indexOf(MAP[i][0]) === 0) return MAP[i][1];
    }
    return null;
  }

  function isShopTab(tab) {
    return labelOf(tab).indexOf("shop") === 0;
  }

  function panelFor(tab) {
    var id = tab.getAttribute("data-target");
    return id ? document.getElementById(id) : null;
  }

  function contentFor(modalId) {
    var moved = document.querySelector('.modal-content[data-wg-in-panel="' + modalId + '"]');
    if (moved) return moved;
    var modal = document.getElementById(modalId);
    return modal ? modal.querySelector(".modal-content") : null;
  }

  function iconSrcFor(modalId) {
    var btn = document.querySelector('.modal-toggle[data-modal="' + modalId + '"]');
    if (!btn) return null;
    var img = btn.querySelector("img");
    return (img && (img.currentSrc || img.src)) || null;
  }

  /* key is whatever we stamp on the holder so we do not redo work on resize */
  function applyIcon(tab, key, src) {
    var holder = tab.querySelector(".nm-tab-icon");
    if (!holder) return;
    if (holder.getAttribute("data-wg-ico") === key) return;
    if (!src) return;
    var svg = holder.querySelector("svg");
    if (svg) svg.setAttribute("data-wg-ico-hidden", "1");
    var span = holder.querySelector(".wg-mm-ico");
    if (!span) {
      span = document.createElement("span");
      span.className = "wg-mm-ico";
      holder.appendChild(span);
    }
    var url = 'url("' + src.replace(/"/g, "%22") + '")';
    span.style.webkitMaskImage = url;
    span.style.maskImage = url;
    holder.setAttribute("data-wg-ico", key);
  }

  function restoreIcon(tab) {
    var holder = tab.querySelector(".nm-tab-icon");
    if (!holder || !holder.getAttribute("data-wg-ico")) return;
    var span = holder.querySelector(".wg-mm-ico");
    if (span && span.parentNode) span.parentNode.removeChild(span);
    var svg = holder.querySelector("svg[data-wg-ico-hidden]");
    if (svg) svg.removeAttribute("data-wg-ico-hidden");
    holder.removeAttribute("data-wg-ico");
  }

  function moveIntoPanels() {
    var tabs = document.querySelectorAll(".nm-tab");
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var modalId = modalIdFor(tab);

      if (!modalId) {
        if (isShopTab(tab)) applyIcon(tab, SHOP_KEY, SHOP_ICON);
        else restoreIcon(tab);
        continue;
      }

      applyIcon(tab, modalId, iconSrcFor(modalId));

      var panel = panelFor(tab);
      var content = contentFor(modalId);
      if (!panel || !content) continue;
      if (content.getAttribute("data-wg-in-panel")) continue;

      if (!document.querySelector('[data-wg-modal-home="' + modalId + '"]')) {
        var marker = document.createElement("span");
        marker.setAttribute("data-wg-modal-home", modalId);
        marker.hidden = true;
        content.parentNode.insertBefore(marker, content);
      }
      content.setAttribute("data-wg-in-panel", modalId);
      content.classList.add("wg-mm-inpanel");
      panel.appendChild(content);
    }
  }

  function moveBackToModals() {
    var moved = document.querySelectorAll(".modal-content[data-wg-in-panel]");
    for (var i = 0; i < moved.length; i++) {
      var content = moved[i];
      var modalId = content.getAttribute("data-wg-in-panel");
      var marker = document.querySelector('[data-wg-modal-home="' + modalId + '"]');
      if (!marker || !marker.parentNode) continue;
      content.removeAttribute("data-wg-in-panel");
      content.classList.remove("wg-mm-inpanel");
      marker.parentNode.insertBefore(content, marker);
    }
    var tabs = document.querySelectorAll(".nm-tab");
    for (var j = 0; j < tabs.length; j++) restoreIcon(tabs[j]);
  }

  function sync() {
    if (window.innerWidth < BREAKPOINT) moveIntoPanels();
    else moveBackToModals();
  }

  function init() {
    sync();
    var t = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(t);
      t = window.setTimeout(sync, 150);
    });
    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(sync, 60);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
